/*eslint-disable*/import type{Messages}from"@lingui/core";export const messages:Messages=JSON.parse("{\"pole-position-ad.promoted-badge\":\"Paalupaikka\"}");